<template>
	<div id="tutorialEditorAppComponent">
		<ValidationObserver ref="observer">
			<AppHeader />
			<FlashMessages />
			<div class="edit-main">
					<div class="edit-main__content--container">
						<AppContent class="edit-main__content" />
					</div>
					<AppSidebar class="edit-main__sidebar" />
			</div>
		</ValidationObserver>
	</div>
</template>
<script>
	import { mapState, mapActions, mapGetters } from 'vuex'
	import AppHeader from './editor/AppHeader'
	import AppSidebar from './editor/AppSidebar'
	import AppContent from './editor/AppContent'
	import FlashMessages from './editor/FlashMessages'

	const NEW_ROUTE = /tutorials\/new/
	const EDIT_ROUTE = /tutorials\/(.*)\/edit/

	export default {
		name: 'app',
		components: {
			AppHeader,
			AppContent,
			AppSidebar,
			FlashMessages
		},
		methods: {
			...mapActions({
				fetchFilters: 'fetchFilters',
				fetchTutorial: 'fetchTutorial',
				checkTooltips: 'checkTooltips'
			})
		},
		computed: {
			...mapState({
				tutorial: 'tutorial',
				activeStep: 'activeStep'
			}),
			...mapGetters([
				'isNew'
			]),
			cachedSlug: {
				get () {
					let route = window.location.pathname
					let match = route.match(EDIT_ROUTE)
					return match && match[1]
				}
			}
		},
		watch: {
			'tutorial.cached_slug': (cachedSlug) => {
				if (NEW_ROUTE.test(location.pathname)) {
					history.replaceState({}, '', `/tutorials/${cachedSlug}/edit`)
				}
			}
		},
		mounted () {
			this.fetchFilters()
			this.checkTooltips()
			if (this.cachedSlug) {
				this.fetchTutorial(this.cachedSlug)
			}

			this.$eventHub.$on('validate', () => {
				this.$refs.observer.validate()
						.then((params) => this.$eventHub.$emit('validationSuccess', params))
						.catch((params) => this.$eventHub.$emit('validationError', params))
			})
		}
	}
</script>

<style src="@/styles/tutorial_editor/helpers.scss" lang="scss"></style>
<style src="@/styles/tutorial_editor/transitions.scss" lang="scss"></style>

<style lang="scss">
	@import "@/styles/tutorial_editor/globals";

	html, body {
		box-sizing: border-box;
		height: 100%;
		width: 100%;
	}

	*, *:before, *:after {
		box-sizing: inherit;
	}

	body {
		margin: 0;
		font-family: $font-family;
		background-color: $white;
	}

	#tutorialEditorAppComponent {
		display: flex;
		flex-direction: column;
		height:100%;
		width:100%;
	}
</style>
